import type { Drama } from '@/mocks/dramas';
import { Link } from 'react-router-dom';

interface DramaCardProps {
  drama: Drama;
}

export default function DramaCard({ drama }: DramaCardProps) {
  return (
    <Link
      to={`/drama/${drama.id}`}
      className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden transition-all duration-300 hover:shadow-md hover:border-primary-200 flex flex-col h-[320px] no-underline"
    >
      <div className="relative w-full h-[70%] overflow-hidden">
        <img
          src={drama.image}
          alt={drama.name}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          onError={(e) => {
            const target = e.currentTarget;
            target.style.display = 'none';
          }}
        />
        <div className="absolute top-2 right-2 px-2 py-1 bg-foreground-950/70 text-background-50 text-xs font-bold rounded-md flex items-center gap-1">
          <i className="ri-star-fill text-accent-500"></i>
          {drama.rating}
        </div>
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
          <span className="px-3 py-1.5 bg-background-50/90 text-foreground-900 text-xs font-medium rounded-full opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
            查看详情
          </span>
        </div>
      </div>
      <div className="p-3 flex flex-col gap-2 h-[30%] justify-center">
        <h3 className="text-sm font-bold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
          {drama.name}
        </h3>
        <div className="flex items-center gap-1.5 flex-wrap">
          <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-[10px] font-medium rounded-full whitespace-nowrap">
            {drama.region}
          </span>
          <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-[10px] font-medium rounded-full whitespace-nowrap">
            {drama.year}
          </span>
          <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-[10px] font-medium rounded-full whitespace-nowrap">
            {drama.genre}
          </span>
        </div>
      </div>
    </Link>
  );
}

export function DramaGrid({ dramas }: { dramas: Drama[] }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {dramas.map((drama) => (
        <DramaCard key={drama.id} drama={drama} />
      ))}
    </div>
  );
}